<template>
  <div class="advance-search-collapse">
    <Collapse v-bind="bindAttrs">
      <div
        slot="content"
        class="search-condtions"
      >
        <slot />
      </div>
    </Collapse>
  </div>
</template>

<script>
import Collapse from './Collapse'

export default {
  name: 'AdvanceSearchCollapse',
  components: {
    Collapse,
  },
  computed: {
    bindAttrs () {
      const attrs = {
        expand: false,
        expandIcons: ['triangle-up', 'triangle-down'],
        withBorder: false,
        enableExpandByClickingTitle: true,
      }
      return Object.assign({ title: this.$t('contact.advanceSearch') }, this.$attrs, attrs)
    },
  },
}

</script>

<style lang="scss" scoped>
::v-deep .title-container {
  width: 300px;
  text-transform: uppercase;
  font-size: 18px;
  .title-content {
    flex: initial;
  }
  .default-title {
    text-transform: uppercase;
    font-size: 18px;
  }
  .triangle-up {
    width: 0;
    height: 0;
    border-left: 6px solid transparent;
    border-right: 6px solid transparent;
    border-bottom: 10px solid #0C3A58;
    display: inline-block;
    margin-left: 5px;
  }
  .triangle-down {
    width: 0;
    height: 0;
    border-left: 6px solid transparent;
    border-right: 6px solid transparent;
    border-top: 10px solid #0C3A58;
    display: inline-block;
    margin-left: 5px;
  }
}
.search-condtions {
  background-color: #F8F8F8;
  padding: 5px 23px 16px 23px;
}
::v-deep .collapse-enter-active {
    animation: easeIn .5s 0s;
    overflow: hidden;
  }
::v-deep .collapse-leave-active {
  animation: easeIn .5s 0s reverse;
  overflow: hidden;
}

@keyframes easeIn {
  0% {
    opacity: 0;
    max-height: 0;
  }
  100% {
    opacity: 1;
    max-height: 100px;
  }
}
.mouse-pointer {
  cursor: pointer;
}

</style>
